/* eslint-disable react/function-component-definition */
import React, { FunctionComponent, useState } from 'react';
import { Interweave } from 'interweave';
import { observer } from 'mobx-react';
import moment from 'moment';

import { BackendEnums } from 'api/codegen';
import { usePublicCompany } from 'client/hooks';
import EllipsisButton from 'components/EllipsisButton';
import { currentLanguage, nl2br } from 'helpers/utils';
import { Card, Feed, Icon, Popup } from 'ui';

interface MessageProps {
  message: Backend.MessageList;
  ticket: {
    customer_name: string;
  };
}

const Message: FunctionComponent<MessageProps> = ({ message, ticket }) => {
  const [expandMessage, setExpandMessage] = useState(false);

  const { company } = usePublicCompany();

  return (
    <Feed.Event
      key={message.id}
      icon={message.type === BackendEnums.MessageListTypeEnum.CUSTOMER_MESSAGE ? 'user' : 'shopping-cart'}
      color={message.type === BackendEnums.MessageListTypeEnum.CUSTOMER_MESSAGE ? 'red' : 'blue'}
      feedIconRingColor="ring-gray-50"
      renderChildren={(children) => (
        <Card flat>
          <Card.Content>{children}</Card.Content>
        </Card>
      )}
    >
      <div className="space-y-4">
        <div>
          <span className="font-medium">
            {message.type === BackendEnums.MessageListTypeEnum.CUSTOMER_MESSAGE
              ? ticket.customer_name
              : currentLanguage(company?.name)}
          </span>
          <div className="text-sm text-gray-500">
            <Popup on="hover" trigger={<span>{moment(message.created_at).fromNow()}</span>}>
              <div className="whitespace-nowrap p-2">{moment(message.created_at).format('LLL')}</div>
            </Popup>
          </div>
        </div>

        {message.additional_text ? (
          <>
            <p>
              <Interweave content={message.text} />
            </p>

            <EllipsisButton onClick={() => setExpandMessage(!expandMessage)} size="tiny" />

            {!!expandMessage && (
              <p style={{ marginBottom: 0 }}>
                <Interweave content={message.additional_text} />
              </p>
            )}
          </>
        ) : (
          <p style={{ marginBottom: 0 }}>
            <Interweave content={message.text} />
          </p>
        )}

        {!!(message.files_data && message.files_data.length) && (
          <div className="space-y-1">
            {message.files_data &&
              message.files_data.map((file) => (
                <div key={`file-${file.id}`}>
                  <a
                    href={file.file}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-700"
                    download={file.filename}
                  >
                    <Icon name="paper-clip" /> {file.filename}
                  </a>
                </div>
              ))}
          </div>
        )}
      </div>
    </Feed.Event>
  );
};

export default observer(Message);
